<div style="display: flex">
    <div>
        <label class="switch {{disable?'switch-disable':''}}">
            <input (ngModelChange)="emitChange($event)" [(ngModel)]="value"
                   [disabled]="disable" type="checkbox">
            <span class="slider round"></span>
        </label>
    </div>
    <div>
<span *ngIf="showLabel" class="switch-label switch-label-pos">
{{value ? onLabel : offLabel}}
</span>
    </div>
</div>

